import setup from 'logrocket/setup';
import { VITE_LOGROCKET_SKD_SERVER, VITE_LOGROCKET_INGEST_SERVER } from 'Constants/appEnvConstants';

const LogRocket = setup({
   sdkServer: VITE_LOGROCKET_SKD_SERVER,
   ingestServer: VITE_LOGROCKET_INGEST_SERVER,
});

export default LogRocket;